import React, {useEffect} from "react";
import "./AsicTech.css";
import AsicCard from "./AsicCard";
import { useInView } from "react-intersection-observer";
import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";
import Textify from "textify.js";
import gsap from "gsap";



import BannerZoom from "./BannerZoom";
import chip1 from "./assets/ai_board_1.jpg";
import chip2 from "./assets/ai_board_2.jpg";
import chip3 from "./assets/ai_board_3.jpg";
import animation1 from "./lottieFiles/ram/Animation - 1711812586610.json";
import BackGround from "./lottieFiles/BackGround1.json";
import AmsDataOne from "./AmsDataOne";

const AsicTech = () => {
  const [ref1, inView1] = useInView({});
  const [ref2, inView2] = useInView({});
  const [ref3, inView3] = useInView({});
  const [ref4, inView4] = useInView({});
  const [ref5, inView5] = useInView({});

  const images = [chip1, chip2, chip3];
  const heading1 = "RTL Design";
  const heading2 =
    "Committed to delivering high-quality design solutions that meet industry standards";

  const variants1 = {
    initial: { opacity: 0, x: 400 },
    visible: { opacity: 1, x: 0 },
  };
  const variants2 = {
    initial: { opacity: 0, x: -400 },
    visible: { opacity: 1, x: 0 },
  };
  const variants3 = {
    initial: { opacity: 0, y: 350 },
    visible: { opacity: 1, y: 0 },
  };
  const variants4 = {
    initial: { opacity: 0, y: 350 },
    visible: { opacity: 1, y: 0 },
  };

  useEffect(() => {
   
    const textifyConfig = {
      el: ".raamm",
      observer: {
        repeat: true,
      },
      animation: {
        duration: 1,
        stagger: 0.1,
        ease: "expo.inOut",
        transformOrigin: "left right",
        animateProps: {
          x: "-100%",
          y: "0%",
        },
      },
    };

    const paragraphConfig = {
      el: ".ramParagraph",
      largeText: true,
      splitType: "lines",
      observer: {
        repeat: true,
      },
      animation: {
        by: "lines",
        duration: 2,
        ease: "power3.inOut",
        stagger: 0.1,
        animateProps: {
          scale: 0.5,
          opacity: 0,
        },
      },
    };

    // const title2Config = {
    //   el: ".ramHeading",
    //   observer: {
    //     repeat: true,
    //   },
    //   animation: {
    //     duration: 0.7,
    //     ease: "power2.inOut",
    //     transformOrigin: "left top",
    //     animateProps: {
    //       y: "0",
    //       rotate: -180,
    //       scale: 0,
    //     },
    //   },
    // };

    // const paragraph3Config = {
    //   el: ".paragraph-3",
    //   observer: {
    //     repeat: true,
    //   },
    //   // largeText: true,
    //   // splitType: "lines",
    //   animation: {
    //     by: "lines",
    //     duration: 0.7,
    //     ease: "power3.inOut",
    //     stagger: 0.1,
    //     transformOrigin: "left top",
    //     animateProps: {
    //       rotate: 30,
    //       opacity: 0,
    //     },
    //   },
    // };

    const RamConfig = {
      el: ".downtoup",
      largeText: true,
      splitType: "lines",
      observer: {
        repeat: true,
      },
      animation: {
        by: "lines",
        duration: 2,
        ease: "power3.inOut",
        stagger: 0.1,
        animateProps: {
          // Define custom properties and their values for animation
          opacity: 0, // Animate opacity from 0 to 1
          x: "-100px", // Animate horizontal position by 100 pixels
          y: "-50px", // Animate vertical position by -50 pixels
          scale: 2, // Animate scale to double the size
          // rotate: 360, // Animate rotation by 360 degrees
        },
      },
    };

    // Initialize Textify for banner title and paragraph with GSAP
    const titleInstance = new Textify(textifyConfig, gsap);
    const paragraphInstance = new Textify(paragraphConfig, gsap);
    // const title2Instance = new Textify(title2Config, gsap);
    // const paragraph3Instance = new Textify(paragraph3Config, gsap);
    const textifyInstance = new Textify(RamConfig, gsap);
  }, []); 




  const TechData = [
    {
      id: 1,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M58.5,53.2c-0.1,0.2-0.1,0.3-0.2,0.5c-0.5,1.5-2,2.5-3.6,2.3c-1.6-0.2-2.8-1.6-2.8-3.2c0-1.6,1.2-3,2.7-3.2c1.7-0.3,3.2,0.6,3.7,2.2c0.1,0.2,0.1,0.3,0.2,0.5C58.5,52.5,58.5,52.9,58.5,53.2z" />
            <path d="M1.5,52.2c0.1-0.2,0.1-0.3,0.2-0.5c0.5-1.6,2.1-2.4,3.7-2.2C6.9,49.8,8,51.2,8,52.7c0,1.6-1.2,3-2.7,3.2c-1.6,0.3-3.1-0.7-3.6-2.2c-0.1-0.2-0.1-0.3-0.2-0.5C1.5,52.9,1.5,52.6,1.5,52.2z" />
            <path d="M21.7,45.4c-1.2,0-2.2,0-3.4,0c0-4.4,0-8.9,0-13.4c-0.8,0-1.5,0-2.3,0c0.1-0.2,0.2-0.4,0.3-0.5c1.6-2.3,3.7-4.1,6.3-5.4c0.3-0.2,0.6-0.1,0.9,0.1c3.9,3,9.2,3,13.1,0c0.3-0.3,0.6-0.3,1-0.1c2.5,1.3,4.6,3,6.2,5.3c0.1,0.1,0.2,0.3,0.4,0.5c-0.9,0-1.6,0-2.5,0c0,4.5,0,8.9,0,13.4c-1.1,0-2.1,0-3.2,0c0-4.4,0-8.9,0-13.3c-5.6,0-11.1,0-16.7,0C21.7,36.5,21.7,40.9,21.7,45.4z" />
            <path d="M37.4,11.5c1.1,0,2.2,0,3.2,0c0,1.1,0,2.2,0,3.3c-7.1,0-14.1,0-21.2,0c0-1.1,0-2.2,0-3.3c1,0,2,0,3,0c0.3-1.8,1.1-3.4,2.6-4.7c0,1.6,0,3.1,0,4.6c1.1,0,2.1,0,3.2,0c0-2.4,0-4.7,0-7.1c1.1,0,2.2,0,3.4,0c0,2.4,0,4.7,0,7.1c1.1,0,2.1,0,3.2,0c0-1.5,0-3,0-4.6C36.3,8.1,37.1,9.6,37.4,11.5z" />
            <path d="M15,45.4c-3.4,0-6.7,0-10.1,0c0-3.4,0-6.7,0-10.1c3.4,0,6.7,0,10.1,0C15,38.7,15,42,15,45.4z" />
            <path d="M24.9,35.3c3.4,0,6.7,0,10.1,0c0,3.4,0,6.7,0,10.1c-3.4,0-6.7,0-10.1,0C24.9,42.1,24.9,38.7,24.9,35.3z" />
            <path d="M44.8,35.3c3.4,0,6.7,0,10.1,0c0,3.4,0,6.7,0,10.1c-3.4,0-6.7,0-10.1,0C44.8,42.1,44.8,38.7,44.8,35.3z" />
            <path d="M22.5,18.1c5,0,10,0,14.9,0c0.2,2.8-2.4,6.9-7,7.2C26.3,25.6,22.5,22.2,22.5,18.1z" />
            <path d="M24.9,52.7c0,1.8-1.5,3.2-3.3,3.2c-1.8,0-3.3-1.5-3.2-3.3c0-1.8,1.5-3.2,3.3-3.2C23.5,49.5,24.9,50.9,24.9,52.7z" />
            <path d="M41.7,52.7c0,1.8-1.5,3.2-3.3,3.2c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.2,3.3-3.2C40.3,49.5,41.7,50.9,41.7,52.7z" />
            <path d="M10.5,55.9c1.1-3,1.1-3.9,0-6.4c1.8,0,3.6,0,5.5,0c-1.1,2.1-1.1,4.3,0,6.4C14.1,55.9,12.4,55.9,10.5,55.9z" />
            <path d="M27.3,55.9c1.1-2.2,1.1-4.3,0-6.5c1.8,0,3.6,0,5.5,0c-1.1,2.1-1.1,4.3,0,6.5C31,55.9,29.2,55.9,27.3,55.9z" />
            <path d="M49.6,56c-1.9,0-3.7,0-5.5,0c1.1-2.2,1.1-4.3,0-6.5c1.8,0,3.6,0,5.5,0C48.5,51.6,48.5,53.8,49.6,56z" />
          </g>
        </svg>
      ),
      title: "ASIC/FPGA",
    },
    {
      id: 2,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M49.2,19.2c-0.3-2.2-1.6-3.4-3.8-3.4c-1.2,0-2.3,0-3.5,0c-2.5,0-3.6,0.9-4.1,3.4c-0.7,0-1.4,0-2.2,0c0-1.8,0.7-3.2,2.1-4.3c1.3-1.1,3-1.4,4.7-1.3c0-0.8,0-1.5,0-2.3c-0.2,0-0.5,0-0.7,0c-12,0-23.9,0-35.9,0c-2.4,0-4.2-1.5-4.6-3.7C0.6,4.9,2.6,2.4,5.3,2.2c0.1,0,0.2,0,0.3,0c16.2,0,32.4,0,48.7,0c2.2,0,4.1,1.5,4.5,3.7c0.5,2.8-1.5,5.4-4.4,5.4c-3,0-6,0-9,0c-0.2,0-0.4,0-0.6,0c0,0.8,0,1.5,0,2.3c2.1-0.2,4,0.3,5.4,2c0.9,1,1.3,2.2,1.4,3.6C50.7,19.2,50,19.2,49.2,19.2z" />
            <path d="M30,43c6.4,0,12.8,0,19.2,0c4.2,0,7.4,3.4,7.4,7.5c-0.1,3.9-3.3,7.2-7.2,7.2c-4.2,0-8.4,0-12.6,0c-8.7,0-17.4,0-26.1,0c-4.1,0-7.4-3.3-7.4-7.4c0-4,3.3-7.3,7.3-7.3C17.1,43,23.5,43,30,43z M14.1,45.3c-2.8,0-5.1,2.3-5.1,5c0,2.8,2.3,5.1,5.1,5.2c2.8,0,5.1-2.3,5.1-5C19.2,47.6,16.9,45.3,14.1,45.3z M35,50.4c0-2.8-2.3-5.1-5.1-5.1c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1C32.7,55.5,35,53.2,35,50.4z M50.9,50.4c0-2.8-2.3-5.1-5.1-5.1c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1C48.6,55.5,50.9,53.2,50.9,50.4z" />
            <path d="M49.2,35.1c-3.8,0-7.5,0-11.3,0c0-3.8,0-7.5,0-11.3c0.7,0,1.4,0,2.2,0c0,1.5,0,3,0,4.5c2.3,0,4.5,0,6.8,0c0-1.5,0-2.9,0-4.5c0.8,0,1.5,0,2.2,0C49.2,27.5,49.2,31.3,49.2,35.1z" />
            <path d="M19.7,33.9c0-1.5,0-3,0-4.5c0.8,0,1.5,0,2.2,0c0,3.8,0,7.5,0,11.3c-3.8,0-7.5,0-11.3,0c0-3.7,0-7.5,0-11.3c0.7,0,1.4,0,2.2,0c0,1.5,0,3,0,4.5C15.2,33.9,17.4,33.9,19.7,33.9z" />
            <path d="M35.6,40.7c-3.8,0-7.5,0-11.3,0c0-3.8,0-7.5,0-11.3c0.7,0,1.4,0,2.2,0c0,1.5,0,3,0,4.5c2.3,0,4.5,0,6.8,0c0-1.5,0-2.9,0-4.5c0.8,0,1.5,0,2.2,0C35.6,33.2,35.6,36.9,35.6,40.7z" />
            <path d="M44.6,26c-0.7,0-1.4,0-2.2,0c0-0.7,0-1.5,0-2.2c0.7,0,1.4,0,2.2,0C44.6,24.5,44.6,25.3,44.6,26z" />
            <path d="M15.3,29.4c0.8,0,1.5,0,2.2,0c0,0.7,0,1.4,0,2.2c-0.7,0-1.4,0-2.2,0C15.3,30.9,15.3,30.2,15.3,29.4z" />
            <path d="M31,31.7c-0.7,0-1.4,0-2.2,0c0-0.7,0-1.5,0-2.2c0.7,0,1.4,0,2.2,0C31,30.2,31,30.9,31,31.7z" />
            <path d="M14.1,47.5c1.6,0,2.8,1.3,2.8,2.8c0,1.6-1.3,2.8-2.8,2.8c-1.5,0-2.8-1.3-2.8-2.8C11.2,48.8,12.5,47.5,14.1,47.5z" />
            <path d="M29.9,47.5c1.6,0,2.8,1.3,2.8,2.8c0,1.6-1.3,2.8-2.9,2.8c-1.5,0-2.8-1.3-2.8-2.8C27.1,48.8,28.4,47.5,29.9,47.5z" />
            <path d="M45.8,47.5c1.6,0,2.8,1.3,2.8,2.9c0,1.6-1.3,2.8-2.9,2.8c-1.5,0-2.8-1.3-2.8-2.8C43,48.8,44.3,47.5,45.8,47.5z" />
          </g>
        </svg>
      ),
      title: "Verilog / System Verilog",
    },
    {
      id: 3,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M48.4,58.6c-5.6,0-11.2,0-16.8,0c0-7.2,0-14.4,0-21.7c0-1.2-0.7-1.9-1.9-1.9c-0.8,0-1.7,0-2.5,0c-0.8,0-1.5,0-2.3,0c0-0.3,0-0.5,0-0.7c0-3.6,0-7.2,0-10.8c0-0.7-0.3-1.3-0.9-1.7c-1.1-0.6-2.4,0.2-2.4,1.6c0,3.7,0,7.3,0,11c0,0.2,0,0.4,0,0.6c-2.3,0-4.5,0-6.7,0c0-2.3,0-4.7,0-7c0.2-0.1,0.3-0.1,0.4-0.2c2-1,3.2-3.1,2.9-5.1c-0.4-2.4-2.1-4.1-4.4-4.4c-2.1-0.3-4.2,0.9-5.1,2.9c-0.2,0.3-0.3,0.4-0.7,0.4c-2.2,0-4.4,0-6.6,0c0-6.3,0-12.7,0-19c0.3-0.6,0.7-1,1.2-1.2c1.9,0,3.7,0,5.6,0c0,3.8,0,7.7,0,11.5c0,1.4,0.6,2,2,2c3.7,0,7.4,0,11.1,0c0.5,0,0.7,0.1,0.9,0.6c1.2,2.4,4,3.4,6.4,2.4c2.5-1.1,3.7-3.9,2.7-6.4c-0.9-2.5-3.7-3.8-6.2-3c-1.6,0.5-2.6,1.6-3.2,3.1c-3.5,0-6.9,0-10.4,0c0-3.4,0-6.8,0-10.1c7.8,0,15.6,0,23.5,0c0,5,0,10,0,15c0,1.2,0.7,1.8,1.8,1.8c2.1,0,4.2,0,6.4,0c1.1,0,1.8-0.7,1.9-1.7c0-1-0.7-1.7-1.8-1.7c-1.4,0-2.9,0-4.3,0c-0.2,0-0.4,0-0.6,0c0-4.5,0-9,0-13.5c3.4,0,6.7,0,10.1,0c0,2.3,0,4.5,0,6.8c-1.7,0-3.2,0-4.8,0c-1.1,0-1.9,0.7-1.9,1.7c0,1,0.8,1.7,1.9,1.7c1.4,0,2.9,0,4.3,0c0.2,0,0.4,0,0.5,0c0,4.5,0,8.9,0,13.4c-0.1,0-0.2,0-0.2,0c-3.2,0-6.5,0-9.7,0c-0.3,0-0.4-0.2-0.5-0.4c-0.9-1.8-2.3-2.8-4.3-2.9c-2.6-0.1-4.7,1.6-5.2,4.2c-0.4,2.4,1,4.8,3.4,5.6c2.4,0.8,5-0.3,6.1-2.7c0.2-0.3,0.3-0.4,0.7-0.4c3.7,0,7.4,0,11.2,0c1.5,0,2.1-0.6,2.1-2.1c0-8.3,0-16.6,0-24.9c1.9,0,3.7,0,5.6,0c0.6,0.3,1,0.7,1.2,1.2c0,10.8,0,21.6,0,32.4c-6.1,0-12.2,0-18.3,0c-1.2,0-1.9,0.7-1.9,1.9c0,1.5,0,3,0,4.5c0,0.5-0.1,0.7-0.6,0.9c-2.4,1.1-3.4,3.9-2.4,6.4c1,2.5,3.8,3.7,6.3,2.8c2.5-0.9,3.9-3.6,3.1-6.1c-0.5-1.6-1.6-2.7-3.1-3.3c0-1.2,0-2.4,0-3.7c5.6,0,11.2,0,16.8,0c0,6.3,0,12.7,0,19c-0.3,0.6-0.7,1-1.2,1.2c-1.9,0-3.7,0-5.6,0c0-1.5,0-2.9,0-4.4c0-3.5,0-7.1,0-10.6c0-0.8-0.3-1.3-1-1.7c-1.2-0.6-2.4,0.3-2.4,1.6C48.4,48.6,48.4,53.6,48.4,58.6z" />
            <path d="M1.4,57.4c0-10.8,0-21.6,0-32.4c2.2,0,4.4,0,6.6,0c0.3,0,0.5,0.1,0.7,0.4c0.5,1.1,1.3,1.9,2.4,2.4c0.3,0.2,0.5,0.3,0.4,0.7c0,2.6,0,5.2,0,7.9c0,1.4,0.6,2,2,2c4.7,0,9.4,0,14.1,0c0.2,0,0.4,0,0.7,0c0,6.8,0,13.5,0,20.2c-1.1,0-2.2,0-3.4,0c0-3.9,0-7.7,0-11.6c0-1.2-0.7-1.9-1.9-1.9c-1.5,0-3,0-4.5,0c-0.5,0-0.7-0.1-0.9-0.6c-1.2-2.4-4-3.4-6.4-2.4c-2.5,1.1-3.7,3.8-2.7,6.4c0.9,2.5,3.6,3.9,6.2,3.1c1.6-0.5,2.7-1.6,3.3-3.1c1.2,0,2.4,0,3.7,0c0,3.4,0,6.8,0,10.1c-6.3,0-12.7,0-19,0C2.1,58.3,1.7,57.9,1.4,57.4z" />
            <path d="M13.3,21.6c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.6-0.8-1.6-1.7C11.6,22.4,12.4,21.6,13.3,21.6z" />
            <path d="M35,26.6c0,0.9-0.7,1.7-1.6,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7C34.3,25,35,25.7,35,26.6z" />
            <path d="M28.3,13.3c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.6,1.7-1.6C27.6,11.6,28.3,12.4,28.3,13.3z" />
            <path d="M41.7,46.8c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.6C41,45.1,41.7,45.9,41.7,46.8z" />
            <path d="M13.2,45.1c0.9,0,1.7,0.7,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7C11.6,45.8,12.3,45.1,13.2,45.1z" />
          </g>
        </svg>
      ),
      title: "Lint & CDC",
    },
    {
      id: 4,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M43.1,51c-2.4,1.5-4.8,2.5-7.5,3.1c0,1.2,0,2.4,0,3.7c0,0.9-0.3,1.2-1.2,1.2c-2.9,0-5.9,0-8.8,0c-0.9,0-1.2-0.3-1.2-1.2c0-1.2,0-2.4,0-3.7c-2.7-0.7-5.2-1.7-7.6-3.2c-0.4,0.4-0.8,0.9-1.2,1.3c-0.5,0.5-1,1-1.5,1.5c-0.5,0.4-0.9,0.5-1.4,0c-2.2-2.2-4.4-4.4-6.6-6.6c-0.5-0.5-0.4-0.9,0.1-1.4C7.1,44.9,8,44,8.9,43.1c-1.4-2.3-2.5-4.8-3.1-7.6c-1.2,0-2.4,0-3.5,0c-1.1,0-1.4-0.2-1.4-1.4c0-2.9,0-5.7,0-8.6c0-0.9,0.3-1.2,1.2-1.2c1.2,0,2.4,0,3.7,0c0.6-2.7,1.7-5.2,3.1-7.5c-0.9-0.9-1.7-1.7-2.6-2.6c-0.7-0.7-0.7-1.1,0-1.7c2.1-2.1,4.1-4.1,6.2-6.2c0.7-0.7,1.1-0.7,1.7,0C15.1,7.1,16,8,16.8,8.9c2.4-1.5,4.9-2.5,7.5-3.1c0-1.2,0-2.5,0-3.7c0-0.9,0.3-1.2,1.2-1.2c2.9,0,5.9,0,8.8,0c0.9,0,1.2,0.3,1.2,1.2c0,1.2,0,2.4,0,3.7c2.7,0.6,5.2,1.7,7.5,3.1C44,8,44.8,7.2,45.7,6.3c0.7-0.7,1.1-0.7,1.8,0c2.1,2.1,4.1,4.1,6.2,6.2c0.7,0.7,0.7,1.1,0,1.7c-0.9,0.9-1.7,1.7-2.6,2.6c1.5,2.4,2.5,4.8,3.1,7.5c1.3,0,2.5,0,3.7,0c0.9,0,1.2,0.3,1.2,1.2c0,3,0,5.9,0,8.9c0,0.8-0.3,1.1-1.1,1.1c-1.1,0-2.2,0-3.4,0c-0.2,0-0.4,0.2-0.5,0.3c-0.6,2.5-1.7,4.9-3.1,7.2c0.8,0.8,1.7,1.7,2.5,2.5c0.7,0.7,0.7,1.1,0,1.9c-2,2-4.1,4.1-6.1,6.1c-0.7,0.7-1.1,0.7-1.8,0C44.8,52.8,44,51.9,43.1,51z M26.2,57.2c2.6,0,5,0,7.6,0c0-1.2,0-2.3,0-3.5c0-0.8,0.2-1.1,1-1.3c2.7-0.6,5.3-1.6,7.6-3.2c0.8-0.5,1.1-0.5,1.7,0.2c0.8,0.8,1.6,1.6,2.3,2.4c1.8-1.8,3.6-3.6,5.4-5.4c-0.7-0.7-1.5-1.5-2.3-2.3c-0.7-0.7-0.7-1-0.2-1.8c1.5-2.3,2.5-4.8,3.1-7.5c0.2-0.9,0.4-1.1,1.4-1.1c1.1,0,2.2,0,3.4,0c0-2.5,0-5,0-7.6c-1.2,0-2.3,0-3.4,0c-0.9,0-1.1-0.2-1.3-1c-0.6-2.7-1.6-5.3-3.2-7.6c-0.5-0.8-0.5-1.1,0.2-1.7c0.8-0.8,1.6-1.6,2.3-2.3c-1.8-1.8-3.6-3.6-5.4-5.4c-0.8,0.8-1.5,1.5-2.3,2.3c-0.7,0.7-1,0.8-1.8,0.2C40,9.1,37.5,8,34.8,7.5c-0.8-0.2-1-0.4-1-1.3c0-1.1,0-2.3,0-3.4c-2.6,0-5,0-7.6,0c0,1.1,0,2.3,0,3.4c0,1-0.2,1.2-1.1,1.4C22.4,8,20,9,17.7,10.5c-1.1,0.7-1.2,0.7-2.1-0.2c-0.7-0.7-1.5-1.5-2.2-2.2c-1.8,1.8-3.6,3.6-5.4,5.4c0.8,0.8,1.7,1.7,2.5,2.5c0.4,0.4,0.5,0.8,0.2,1.3c-1.6,2.5-2.8,5.2-3.4,8.1c-0.1,0.6-0.5,0.8-1.1,0.8c-1,0-2.1,0-3.1,0c-0.2,0-0.4,0-0.5,0c0,2.5,0,5,0,7.5c1.2,0,2.3,0,3.4,0c0.9,0,1.1,0.2,1.3,1.1c0.6,2.7,1.6,5.2,3.1,7.5c0.6,0.9,0.5,1.1-0.2,1.9c-0.8,0.8-1.5,1.6-2.3,2.3c1.8,1.8,3.6,3.6,5.4,5.4c0.8-0.8,1.6-1.6,2.4-2.4c0.6-0.6,0.9-0.6,1.6-0.2c2.4,1.5,5,2.6,7.7,3.2c0.8,0.2,1,0.4,1,1.3C26.2,54.9,26.2,56,26.2,57.2z" />
            <path d="M45.8,15.5c-0.6,0.6-1.2,1.2-1.7,1.8c6.5,7.2,6.4,18.2,0,25.3c0.6,0.6,1.1,1.1,1.7,1.7c0-0.3,0-0.5,0-0.8c0-0.5,0.3-0.9,0.8-0.9c0.5,0,0.9,0.2,1,0.8c0.1,1.2,0.2,2.4,0.2,3.6c0,0.5-0.4,0.9-0.9,0.9c-1.1,0-2.3-0.1-3.4-0.2c-0.6-0.1-0.9-0.5-0.9-1c0.1-0.5,0.4-0.8,1-0.8c0.2,0,0.5,0,0.9,0.1c-0.4-0.4-0.7-0.7-0.9-1c-0.3-0.3-0.5-0.6-0.8-0.9c-3.7,3.2-7.9,4.9-12.8,4.9c-4.8,0-9.1-1.7-12.8-5c-0.3,0.3-0.5,0.6-0.8,0.9c-0.3,0.3-0.6,0.5-0.9,0.8c0,0.1,0,0.1,0.1,0.2c0.3,0,0.5,0,0.8,0c0.6,0,0.9,0.3,1,0.8c0.1,0.5-0.3,0.9-0.9,1c-1.2,0.1-2.3,0.2-3.5,0.2c-0.5,0-0.9-0.4-0.9-0.9c0-1.2,0.1-2.3,0.2-3.5c0.1-0.6,0.5-0.9,1-0.8c0.5,0,0.8,0.4,0.8,1c0,0.3,0,0.5,0,0.9c0.1-0.1,0.2-0.1,0.2-0.2c0.5-0.5,1.1-1,1.6-1.5c-6.6-7.3-6.5-18.4-0.1-25.5c-0.6-0.6-1.1-1.1-1.7-1.7c0,0.3,0,0.6,0,0.9c0,0.5-0.3,0.9-0.8,0.9c-0.5,0-0.9-0.2-1-0.8c-0.1-1.2-0.2-2.4-0.2-3.6c0-0.5,0.4-0.9,0.9-0.9c1.1,0,2.3,0.1,3.4,0.2c0.6,0.1,0.9,0.5,0.9,1c0,0.5-0.4,0.8-1,0.8c-0.2,0-0.5,0-0.7,0c0.6,0.5,1.1,1.1,1.7,1.7C20.9,12.7,25.1,11,30,11c4.8,0,9.1,1.7,12.7,4.8c0.6-0.6,1.1-1.2,1.7-1.7c-0.2,0-0.5,0-0.7,0c-0.6,0-0.9-0.3-1-0.8c-0.1-0.5,0.3-0.9,0.8-1c1.2-0.1,2.3-0.2,3.5-0.2c0.5,0,0.9,0.4,0.9,0.9c0,1.2-0.1,2.3-0.2,3.5c-0.1,0.6-0.5,0.9-1,0.8c-0.5,0-0.8-0.4-0.8-1C45.8,16.1,45.8,15.8,45.8,15.5z M30.9,38.8c0.1,0,0.3-0.1,0.4-0.1c3.4-1.3,6.8-2.6,10.1-3.9c0.3-0.1,0.4-0.3,0.4-0.6c0-2.5,0-5.1,0-7.6c0-0.1,0-0.3,0-0.4c-0.1,0-0.1,0-0.2,0c-3.4,1.3-6.9,2.7-10.3,4c-0.3,0.1-0.4,0.3-0.3,0.6c0,2.5,0,5,0,7.5C30.9,38.4,30.9,38.6,30.9,38.8z M26.7,29.4c0,0.4,0,0.8,0,1.1c0,0.4,0,0.7,0,1.1c-0.1,0.9-1,1.3-1.7,0.8c-0.3-0.2-0.6-0.4-0.8-0.7c-0.6-0.7-1.2-0.7-1.9-0.4c-1.1,0.4-1.7-0.1-1.7-1.2c0-0.9,0-1.8,0-2.7c0-0.2-0.1-0.4-0.2-0.5c-0.7-0.3-1.4-0.6-2.1-0.8c0,0.2,0,0.4,0,0.6c0,2.5,0,4.9,0,7.4c0,0.4,0.1,0.6,0.5,0.8c3.2,1.2,6.4,2.5,9.6,3.7c0.2,0.1,0.5,0.2,0.8,0.3c0-2.8,0-5.5,0-8.2c0-0.1-0.1-0.3-0.2-0.4C28.1,29.9,27.4,29.7,26.7,29.4z M28.3,28c0.4,0.1,0.6,0.2,0.8,0.3c0.6,0.3,1.1,0.3,1.7,0c2.4-1,4.7-1.9,7.1-2.8c0.7-0.3,1.4-0.5,2.2-0.9c-0.9-0.4-1.7-0.8-2.7-0.3c-1.4,0.7-2.8,1.1-4.2,1.7C31.6,26.7,30,27.3,28.3,28z M31.7,21.4c-0.5-0.2-0.9-0.4-1.3-0.5c-0.2-0.1-0.5-0.1-0.8,0c-3.1,1.2-6.2,2.4-9.3,3.6c-0.1,0-0.2,0.1-0.3,0.2c1,0.7,1.9,0.7,2.9,0.1c0.1-0.1,0.2-0.1,0.4-0.1C26,23.6,28.7,22.6,31.7,21.4z" />
          </g>
        </svg>
      ),
      title: "Spyglass/Xilinx/Vivado Etc.",
    },
    {
      id: 5,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M33,59.1c0-0.2,0.1-0.5,0.1-0.7c0-6.9,0-13.7,0-20.6c0-0.2,0-0.5,0-0.7c0.2,0,0.4,0,0.5,0c8.4,0,16.9,0,25.3,0c0.1,0,0.2,0,0.3,0c0,6.6,0,13.1,0,19.7c-0.4,1.2-1.2,2-2.4,2.4C48.8,59.1,40.9,59.1,33,59.1z M46,56.1c0-1.3,0-2.6,0-3.9c-2,0-4,0-5.9,0c0,1.3,0,2.6,0,3.9C42.1,56.1,44,56.1,46,56.1z M50.1,52.1c0,1.3,0,2.6,0,4c2,0,4,0,5.9,0c0-1.3,0-2.6,0-4C54.1,52.1,52.1,52.1,50.1,52.1z" />
            <path d="M59.1,15c-0.2,0-0.5,0-0.7,0c-9.5,0-19,0-28.6,0c-0.2,0-0.5,0-0.8,0c0-0.3,0-0.5,0-0.7c0-3.2,0-6.5,0-9.7c0-2.1,0.5-2.9,2.5-3.7c8.4,0,16.8,0,25.2,0c1.2,0.4,2,1.2,2.4,2.4C59.1,7.2,59.1,11.1,59.1,15z M34,11.9c2.7,0,5.3,0,8,0c0-2.7,0-5.3,0-7.9c-2.7,0-5.3,0-8,0C34,6.6,34,9.2,34,11.9z M45.1,12.9c3.4,0,6.7,0,10,0c0-0.7,0-1.3,0-1.9c-3.3,0-6.7,0-10,0C45.1,11.6,45.1,12.3,45.1,12.9z M45,6.9c0,0.5,0,1,0,1.4c0,0.5,0.1,0.6,0.6,0.6c3,0,5.9,0,8.9,0c0.2,0,0.4,0,0.6,0c0-0.7,0-1.3,0-2C51.7,6.9,48.4,6.9,45,6.9z M45.1,4.9c3.3,0,6.7,0,10,0c0-0.7,0-1.3,0-1.9c-3.3,0-6.6,0-10,0C45.1,3.6,45.1,4.2,45.1,4.9z" />
            <path d="M0.9,37c1.3,0,2.6,0,4,0c0,0.2,0,0.5,0,0.7c0,4.1,0,8.1,0,12.2c0,2.5,1.5,4.5,3.9,5.1c0.5,0.1,0.9,0.1,1.4,0.1c3.8,0,7.7,0,11.5,0c3.1,0,5.3-2.1,5.3-5.3c0-4,0-8,0-12c0-0.2,0-0.5,0-0.8c1.3,0,2.6,0,4,0c0,7.3,0,14.7,0,22c-9.2,0-18.5,0-27.7,0c-1.2-0.4-2-1.2-2.4-2.4C0.9,50.2,0.9,43.6,0.9,37z" />
            <path d="M59.1,18.5c-0.3,0.5-0.4,1-0.8,1.4c-0.6,0.8-1.6,1-2.6,1c-6.7,0-13.4,0-20.2,0c-1,0-2-0.1-3,0c-2.3,0.1-3.9-1.5-3.5-4c0.2,0,0.5,0,0.7,0c9.5,0,19.1,0,28.6,0c0.2,0,0.5,0,0.7,0C59.1,17.5,59.1,18,59.1,18.5z" />
            <path d="M59.1,35c-8.6,0-17.2,0-25.7,0c-0.1,0-0.2,0-0.3,0c0-1.3,0-2.6,0-4c0.2,0,0.4,0,0.7,0c7.2,0,14.4,0,21.6,0c1.9,0,3.2,0.6,3.8,2.4C59.1,33.9,59.1,34.5,59.1,35z" />
            <path d="M0.9,33.4c0.4-0.6,0.7-1.3,1.2-1.8c0.7-0.7,1.7-0.7,2.8-0.6c0,1.3,0,2.6,0,4c-1.3,0-2.7,0-4,0C0.9,34.5,0.9,33.9,0.9,33.4z" />
            <path d="M7,31c6,0,12,0,18,0c0,6,0,12,0,18c-6,0-12,0-18,0C7,43,7,37.1,7,31z M12.9,42c-0.7,0-1.4,0-2.1,0c-0.5,0-0.8,0.3-0.9,0.8c0,0.8,0,1.6,0,2.4c0,0.4,0.4,0.7,0.8,0.8c0.7,0,1.4,0,2.2,0C12.9,44.7,12.9,43.4,12.9,42z M19,42c0,1.4,0,2.7,0,4c0.7,0,1.4,0,2.1,0c0.5,0,0.9-0.4,0.9-0.9c0-0.7,0-1.4,0-2.1c0-0.6-0.4-0.9-1-1C20.3,42,19.7,42,19,42z M16.9,46c0-1.3,0-2.6,0-3.9c-0.6,0-1.3,0-1.9,0c0,1.3,0,2.6,0,3.9C15.6,46,16.2,46,16.9,46z" />
            <path d="M24.7,51.1c-0.4,1.1-1.4,2-2.6,2c-4.1,0-8.2,0-12.3,0c-1.2,0-2.3-0.8-2.6-2C13,51.1,18.9,51.1,24.7,51.1z" />
            <path d="M36.2,29c0.3-0.8,0.8-1.3,1.6-1.6c0.6-0.2,1.2-0.4,1.9-0.4c2.9,0,5.9-0.1,8.8,0c0.7,0,1.5,0.3,2.2,0.6c0.6,0.2,0.9,0.7,1.2,1.4C46.6,29,41.5,29,36.2,29z" />
            <path d="M48,23c0,0.7,0,1.3,0,2c-2.7,0-5.3,0-8,0c0-0.7,0-1.3,0-2C42.7,23,45.4,23,48,23z" />
            <path d="M31,31.1c0,1.3,0,2.6,0,3.9c-1.3,0-2.6,0-4,0c0-1.3,0-2.6,0-3.9C28.3,31.1,29.6,31.1,31,31.1z" />
          </g>
        </svg>
      ),
      title: "Synthesis",
    },
    {
      id: 6,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M43.1,51.3c-0.1,0.1-0.3,0.1-0.4,0.2c-2,1.2-4.2,2.1-6.5,2.7c-0.2,0.1-0.5,0.3-0.6,0.6c-0.5,1.3-1,2.6-1.5,4c-0.1,0.3-0.3,0.4-0.6,0.4c-2.3,0-4.6,0-7,0c-0.4,0-0.5-0.1-0.6-0.5c-0.5-1.3-1-2.6-1.5-3.9c-0.1-0.3-0.3-0.5-0.7-0.6c-2.2-0.5-4.3-1.4-6.3-2.6c-0.3-0.2-0.6-0.2-1-0.1c-1.3,0.6-2.5,1.1-3.8,1.7c-0.3,0.1-0.5,0.1-0.7-0.1c-1.6-1.7-3.3-3.3-4.9-4.9c-0.3-0.3-0.3-0.5-0.1-0.8c0.6-1.3,1.2-2.5,1.7-3.8c0.1-0.2,0.1-0.6,0-0.9c-1.1-2-2.1-4.1-2.6-6.4c-0.1-0.4-0.3-0.6-0.6-0.7c-1.3-0.5-2.6-1-3.9-1.5C1,34,0.9,33.8,0.9,33.5c0-2.3,0-4.6,0-7c0-0.4,0.1-0.5,0.5-0.6c1.3-0.5,2.6-1,3.9-1.5c0.2-0.1,0.5-0.3,0.5-0.6c0.6-2.3,1.5-4.4,2.7-6.5c0.1-0.2,0.1-0.6,0-0.8c-0.5-1.3-1.1-2.6-1.7-3.9c-0.1-0.3-0.1-0.5,0.1-0.7c1.7-1.6,3.3-3.3,4.9-4.9c0.3-0.3,0.5-0.3,0.8-0.1c1.3,0.6,2.5,1.2,3.8,1.7c0.2,0.1,0.6,0.1,0.9,0c2-1.2,4.2-2.1,6.4-2.6c0.2-0.1,0.5-0.3,0.6-0.6c0.5-1.3,1-2.6,1.5-4C26,1,26.2,0.9,26.5,0.9c2.3,0,4.6,0,7,0c0.4,0,0.5,0.1,0.6,0.5c0.5,1.3,1,2.6,1.5,3.9c0.1,0.2,0.3,0.5,0.6,0.5c2.3,0.6,4.4,1.5,6.5,2.7c0.2,0.1,0.6,0.1,0.8,0c1.3-0.5,2.6-1.1,3.9-1.7c0.3-0.1,0.5-0.1,0.7,0.1c1.6,1.7,3.3,3.3,4.9,4.9c0.3,0.3,0.3,0.5,0.1,0.8c-0.6,1.3-1.2,2.5-1.7,3.8c-0.1,0.2-0.1,0.6,0,0.9c1.1,2,2.1,4.1,2.6,6.4c0.1,0.4,0.3,0.6,0.6,0.7c1.3,0.5,2.6,1,3.9,1.5c0.3,0.1,0.4,0.3,0.4,0.6c0,2.3,0,4.6,0,7c0,0.4-0.1,0.5-0.5,0.6c-1.3,0.5-2.6,1-3.9,1.5c-0.3,0.1-0.5,0.3-0.6,0.7c-0.6,2.2-1.4,4.4-2.6,6.3c-0.2,0.3-0.2,0.6,0,1c0.6,1.3,1.1,2.5,1.7,3.8c0.1,0.3,0.1,0.5-0.1,0.7c-1.7,1.6-3.3,3.3-4.9,4.9c-0.3,0.3-0.5,0.3-0.8,0.1c-1.2-0.6-2.5-1.1-3.7-1.7C43.5,51.4,43.3,51.4,43.1,51.3z M21.1,45.8c7.3,4.2,17.6,2.9,23.5-5c5.7-7.7,4.5-18.4-2.8-24.7c-7.2-6.1-18.1-5.6-24.7,1.1C10.5,24,11,33.4,14,38.3c0.1-0.2,0.3-0.3,0.4-0.5c2.7-2.7,5.3-5.3,8-8c0.5-0.5,0.6-0.5,1.1,0c2.1,2.1,4.2,4.2,6.3,6.3c0.5,0.5,0.5,0.7,0,1.2c-2.7,2.7-5.4,5.4-8.1,8.1C21.6,45.5,21.4,45.6,21.1,45.8z M15.9,41.4c2.3-2.5,4.6-4.8,6.9-7.3c1,1,1.8,1.8,2.6,2.6c0.5,0.5,1.1,0.6,1.5,0.2c0.4-0.4,0.4-1-0.1-1.5c-0.8-0.8-1.7-1.7-2.5-2.5c-1.4-1.4-1.5-1.4-2.8,0c-2.2,2.3-4.4,4.6-6.7,7C15,40.2,15.3,40.7,15.9,41.4z" />
            <path d="M31.1,34.6c-0.4-0.5-0.9-0.9-1.3-1.3c0.1-0.1,0.2-0.3,0.4-0.4c1.6-1.6,3.3-3.3,4.9-4.9c0.5-0.5,1-0.6,1.6-0.4c0.6,0.2,1.2,0.3,1.7,0.5c0.7,0.2,1.3,0.3,2-0.1c0.9-0.6,2.2,0,2.6,1c0.5,1,0,2.2-0.9,2.7c-1,0.5-2.2,0.1-2.7-0.9c-0.2-0.4-0.5-0.6-0.9-0.7c-0.7-0.2-1.5-0.6-2.1-0.5c-0.6,0.2-1.1,1-1.7,1.5c-1.2,1.1-2.3,2.3-3.5,3.5C31.2,34.5,31.2,34.6,31.1,34.6z" />
            <path d="M26.3,29.8c-0.5-0.5-0.9-0.9-1.4-1.4c1.1-1.1,2.2-2.2,3.4-3.4c0.5-0.5,0.9-1,1.4-1.4c0.4-0.3,0.4-0.6,0.3-1.1c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.7-0.4-1.2-1.1-1.6c-1-0.5-1.1-1.9-0.5-2.8c0.6-0.9,1.8-1.1,2.8-0.5c0.9,0.6,1.2,1.8,0.6,2.8c-0.3,0.4-0.3,0.7-0.2,1.1c0.3,0.9,0.5,1.7,0.7,2.6c0.1,0.3,0,0.8-0.2,1C30,26.1,28.2,27.9,26.3,29.8z" />
            <path d="M28.9,32.3c-0.5-0.5-1-0.9-1.5-1.4c0.6-0.6,1.2-1.1,1.7-1.7c1.8-1.8,3.5-3.5,5.3-5.3c0.2-0.2,0.3-0.5,0.3-0.8c0-1.2,0.9-2.1,2.1-2.1c1.2,0,2,0.9,2,2.1c0,1.2-1,2-2.2,1.9c-0.4,0-0.6,0.1-0.9,0.3c-2.1,2.1-4.3,4.3-6.4,6.4C29.1,32,29,32.2,28.9,32.3z" />
          </g>
        </svg>
      ),
      title: "Static Time Analysis",
    },
    {
      id: 6,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M1.6,39.9c0-0.2,0-0.5,0-0.7c0-10.6,0-21.2,0-31.8c0-2.7,1.5-4.2,4.2-4.2c16.3,0,32.5,0,48.8,0c2.7,0,4.2,1.5,4.2,4.2c0,10.6,0,21.2,0,31.8c0,0.2,0,0.4,0,0.6C39.7,39.9,20.7,39.9,1.6,39.9z M43,34.8c-0.6,0.1-1,0.2-1.4,0.2c-0.6,0.1-1,0.5-0.9,1.1c0.1,0.5,0.5,0.8,1.1,0.7c1.2-0.2,2.3-0.3,3.5-0.5c0.7-0.1,0.9-0.5,0.9-1.1c-0.1-1.1-0.3-2.3-0.5-3.4c-0.1-0.7-0.5-1-1.1-0.9c-0.5,0.1-0.8,0.6-0.7,1.2c0.1,0.4,0.1,0.8,0.2,1.3c-1-0.6-1.8-1.1-2.7-1.6c-0.4-0.2-0.5-0.4-0.5-0.9c0-3.6,0-7.1,0-10.7c0-0.9-0.1-1.1-1-1.3c-2.8-1-5.5-1.9-8.3-2.9c-0.4-0.1-0.5-0.3-0.5-0.7c0-0.8,0-1.7,0-2.5c0-0.7,0-1.4,0-2.1c0.1,0,0.1-0.1,0.2-0.1c0.3,0.3,0.6,0.6,0.9,0.9c0.4,0.4,1,0.4,1.3,0.1c0.4-0.4,0.4-0.9-0.1-1.4c-0.8-0.8-1.6-1.7-2.5-2.5c-0.5-0.5-0.9-0.5-1.4,0c-0.8,0.8-1.7,1.6-2.5,2.5c-0.4,0.5-0.5,0.9-0.1,1.3c0.4,0.4,0.9,0.4,1.4-0.1c0.3-0.3,0.6-0.6,0.9-0.9c0,0,0.1,0,0.1,0.1c0,0.2,0,0.3,0,0.5c0,1.4,0,2.7,0,4.1c0,0.4-0.1,0.6-0.5,0.8c-2.7,0.9-5.4,1.9-8.1,2.8c-1,0.4-1.1,0.4-1.1,1.5c0,3.5,0,7,0,10.6c0,0.2,0,0.5-0.1,0.6c-1,0.6-2,1.2-3.1,1.9c0.1-0.6,0.2-1,0.2-1.4c0.1-0.6-0.2-1-0.7-1.1c-0.5-0.1-1,0.2-1.1,0.8c-0.2,1.2-0.4,2.4-0.5,3.6c-0.1,0.7,0.2,1,0.9,1.1c1.1,0.2,2.3,0.3,3.4,0.5c0.6,0.1,1.1-0.2,1.1-0.7c0.1-0.5-0.2-1-0.9-1.1c-0.4-0.1-0.9-0.1-1.4-0.2c1.1-0.6,2-1.2,2.9-1.7c0.3-0.2,0.6-0.2,1-0.1c2.8,1,5.5,2,8.3,2.9c0.4,0.1,0.9,0.1,1.3,0c2.8-0.9,5.5-1.9,8.3-2.9c0.2-0.1,0.5-0.1,0.7,0C40.9,33.5,41.9,34.2,43,34.8z M12.1,6.8c-1,0-2.1,0-3.1,0c-0.9,0-1.8,0-2.7,0c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.3,0.9,0.9,0.9c0.2,0,0.3,0,0.5,0c2.8,0,5.7,0,8.5,0c0.8,0,1.7,0,2.5,0c0.8,0,1.2-0.7,0.9-1.3c-0.2-0.4-0.6-0.5-1-0.5C15.9,6.8,14,6.8,12.1,6.8z M10.2,10.8c-1.2,0-2.4,0-3.6,0c-0.7,0-1.1,0.3-1.1,0.9c0,0.6,0.4,0.9,1.1,0.9c2.4,0,4.8,0,7.1,0c0.7,0,1.1-0.3,1.1-0.9c0-0.6-0.4-0.9-1.1-0.9C12.5,10.8,11.3,10.8,10.2,10.8z" />
            <path d="M1.6,41.8c19.1,0,38.1,0,57.2,0c-0.1,1.1,0,2.2-0.2,3.2c-0.3,1.6-1.8,2.7-3.5,2.7c-1.4,0-2.8,0-4.2,0c-15.1,0-30.2,0-45.3,0c-2.2,0-3.7-1.3-4-3.4C1.6,43.5,1.6,42.7,1.6,41.8z M31.1,44.7c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9C30.7,45.6,31.1,45.2,31.1,44.7z" />
            <path d="M30.2,56.7c-3.9,0-7.8,0-11.8,0c-0.2,0-0.5,0-0.7,0c-0.5-0.1-0.8-0.5-0.8-1c0-0.5,0.3-0.8,0.8-0.9c0.2,0,0.3,0,0.5,0c7.9,0,15.8,0,23.8,0c0.2,0,0.3,0,0.5,0c0.5,0.1,0.8,0.4,0.9,0.9c0,0.5-0.3,0.9-0.8,1c-0.2,0-0.4,0-0.6,0C38,56.7,34.1,56.7,30.2,56.7z" />
            <path d="M37.1,53c-4.6,0-9.2,0-13.8,0c0.5-1.1,0.9-2.2,1.4-3.3c0-0.1,0.3-0.2,0.4-0.2c3.4,0,6.8,0,10.3,0c0.1,0,0.4,0.1,0.4,0.2C36.2,50.8,36.6,51.8,37.1,53z" />
            <path d="M29.2,33.9c-1.3-0.5-2.6-0.9-3.9-1.4c-1.2-0.4-2.4-0.8-3.6-1.3c-0.2-0.1-0.4-0.3-0.4-0.4c0-3.2,0-6.4,0-9.7c0.2,0,0.3,0.1,0.5,0.1c2.4,0.8,4.7,1.6,7.1,2.5c0.2,0.1,0.4,0.3,0.4,0.5c0,3.1,0,6.3,0,9.4C29.3,33.8,29.3,33.8,29.2,33.9z" />
            <path d="M39,21.2c0,0.2,0,0.3,0,0.5c0,3,0,6,0,9c0,0.3,0,0.5-0.4,0.6c-2.4,0.8-4.9,1.7-7.3,2.6c-0.1,0-0.1,0-0.2,0c0-0.2,0-0.3,0-0.5c0-3,0-6,0-8.9c0-0.3,0-0.5,0.4-0.7c2.4-0.8,4.9-1.7,7.3-2.5C38.8,21.2,38.9,21.2,39,21.2z" />
            <path d="M23.2,19.9c0.8-0.3,1.4-0.5,2-0.7c1.5-0.5,3.1-1.1,4.6-1.6c0.2-0.1,0.5-0.1,0.7,0c2.2,0.7,4.3,1.5,6.5,2.2c0.1,0,0.1,0.1,0.3,0.2c-1.6,0.6-3.2,1-4.6,1.7c-1.6,0.7-3.1,0.7-4.7,0C26.4,20.9,24.8,20.5,23.2,19.9z" />
          </g>
        </svg>
      ),
      title: "Clock Domain Crossing Analysis",
    },
    {
      id: 7,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M58.8,38.4c0,2.3,0,4.6,0,6.9c-1.1,0-2.2,0-3.4,0c0-1.2,0-2.3,0-3.4c-1.7,0-3.4,0-5.1,0c0,2.8,0,5.6,0,8.5c-2.9,0-5.6,0-8.4,0c0,1.7,0,3.4,0,5.1c1.1,0,2.2,0,3.4,0c0,1.2,0,2.3,0,3.4c-2.3,0-4.6,0-6.9,0c0-0.1,0-0.2,0-0.3c0-7.1,0-14.2,0-21.3c0-0.1,0-0.3,0-0.5c-0.2,0-0.4,0-0.6,0c-3.6,0-7.2,0-10.9,0c-0.4,0-0.6-0.1-0.8-0.5c-0.9-1.8-2.4-2.8-4.5-2.9c-2.5-0.1-4.7,1.8-5.1,4.2c-0.4,2.5,1.1,4.9,3.5,5.7c2.4,0.8,5-0.4,6.1-2.6c0.2-0.4,0.4-0.6,0.9-0.5c2.5,0,5,0,7.5,0c0.2,0,0.4,0,0.6,0c0,5.7,0,11.3,0,16.9c-1.1,0-2.2,0-3.3,0c0-2.2,0-4.5,0-6.7c-1.2,0-2.2,0-3.4,0c0,2.3,0,4.5,0,6.7c-1.1,0-2.2,0-3.4,0c0-2.2,0-4.5,0-6.7c-1.2,0-2.3,0-3.4,0c0,2.8,0,5.6,0,8.4c-2.3,0-4.6,0-6.9,0c0-1.1,0-2.2,0-3.4c1.2,0,2.3,0,3.4,0c0-1.7,0-3.4,0-5.1c-2.8,0-5.6,0-8.5,0c0-2.8,0-5.6,0-8.5c-1.7,0-3.4,0-5.1,0c0,1.1,0,2.2,0,3.4c-1.2,0-2.3,0-3.4,0c0-2.3,0-4.6,0-6.9c2.8,0,5.6,0,8.4,0c0-1.1,0-2.2,0-3.4c-2.3,0-4.5,0-6.7,0c0-1.1,0-2.2,0-3.4c2.3,0,4.5,0,6.7,0c0-1.1,0-2.2,0-3.3c-2.3,0-4.5,0-6.7,0c0-1.1,0-2.2,0-3.4c2.2,0,4.5,0,6.7,0c0-1.2,0-2.3,0-3.5c-2.8,0-5.6,0-8.4,0c0-2.3,0-4.6,0-6.9c1.1,0,2.2,0,3.4,0c0,1.2,0,2.3,0,3.4c1.7,0,3.4,0,5.1,0c0-2.8,0-5.6,0-8.5c2.9,0,5.6,0,8.4,0c0-1.7,0-3.4,0-5.1c-1.1,0-2.2,0-3.4,0c0-1.2,0-2.3,0-3.4c2.3,0,4.6,0,6.9,0c0,0.1,0,0.1,0,0.2c0,8.3,0,16.5,0,24.8c0,0.1,0,0.3,0.1,0.4c2.7,0,5.4,0,8.1,0c0.5,0,0.7,0.1,0.9,0.6c1,2.1,3.3,3.2,5.6,2.7c2.2-0.5,3.9-2.5,4-4.8c0.1-2.2-1.4-4.3-3.6-5c-2.4-0.7-4.9,0.4-6.1,2.7c-0.1,0.2-0.3,0.4-0.4,0.4c-1.7,0-3.4,0-5.1,0c0-6.8,0-13.6,0-20.3c1.1,0,2.2,0,3.3,0c0,2.3,0,4.5,0,6.7c1.2,0,2.2,0,3.4,0c0-2.3,0-4.5,0-6.7c1.1,0,2.2,0,3.4,0c0,2.2,0,4.5,0,6.7c1.2,0,2.3,0,3.4,0c0-2.8,0-5.6,0-8.4c1.7,0,3.4,0,5.1,0c0,1.1,0,2.2,0,3.4c-0.5,0-1.1,0-1.6,0c0,1.7,0,3.4,0,5.1c2.8,0,5.6,0,8.5,0c0,2.8,0,5.6,0,8.4c1.7,0,3.4,0,5.1,0c0-1.1,0-2.2,0-3.4c1.2,0,2.3,0,3.4,0c0,2.3,0,4.6,0,6.9c-2.8,0-5.6,0-8.4,0c0,1.2,0,2.3,0,3.5c2.3,0,4.5,0,6.7,0c0,1.1,0,2.2,0,3.4c-2.3,0-4.5,0-6.7,0c0,1.1,0,2.2,0,3.3c2.3,0,4.5,0,6.7,0c0,1.1,0,2.2,0,3.4c-2.2,0-4.5,0-6.7,0c0,1.2,0,2.3,0,3.4C53.2,38.4,56,38.4,58.8,38.4z" />
            <path d="M35.1,23.2c0.9,0,1.7,0.7,1.7,1.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7C33.4,24,34.2,23.2,35.1,23.2z" />
            <path d="M23.3,38.4c0,0.9-0.7,1.7-1.6,1.7c-1,0-1.7-0.7-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7C22.5,36.8,23.2,37.5,23.3,38.4z" />
          </g>
        </svg>
      ),
      title: "Area/Power optimizations",
    },
  ];
  return (
    <>
      <section class="wrapper-border bg-light mt-5">
        <BannerZoom images={images} heading1={heading1} heading2={heading2} />
      </section>
      <section class="wrapper-border mt-4">
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: -999,
          }}
        >
          <Player
            autoplay
            loop
            src={BackGround}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>
        <div class="container py-10 py-md-10">
          <motion.div
            ref={ref1}
            initial="initial"
            animate={inView1 ? "visible" : "initial"}
            variants={variants2}
            transition={{ duration: 1, delay: 0.3 }}
            className="card ms-lg-13 mt-1 mb-3 DV-at"
          >
            <div className="card-body">
              <div className="d-flex flex-row">
                <p
                  className="lead fw-bold text-center downtoup"
                  style={{
                    lineHeight: "1.4",
                    letterSpacing: "2px",
                    fontSize: "1.5rem",
                  }}
                >
                  TechsoC offers comprehensive ASIC/FPGA Design Services,
                  leveraging cutting-edge tools, technologies, and expertise.
                  Our offerings include Micro-architecture development, RTL
                  Design, Linting, CDC, LEC and Synthesis.
                </p>
              </div>
            </div>
          </motion.div>

          <div class="row">
            <motion.div
              ref={ref2}
              initial="initial"
              animate={inView2 ? "visible" : "initial"}
              variants={variants2}
              transition={{ duration: 1, delay: 1 }}
              className="col-md-5 col-lg-5 mb-1"
            >
              <Player
                src={animation1}
                className="player"
                loop
                autoplay
                style={{ height: "600px", width: "100%" }}
              />
            </motion.div>
            <motion.div
              ref={ref3}
              initial="initial"
              animate={inView3 ? "visible" : "initial"}
              variants={variants1}
              transition={{ duration: 1, delay: 1 }}
              className="col-md-7 col-lg-7 mb-1"
              style={{ color: "#407AFF" }}
            >
              <div
                className="card RTL-at"
                style={{
                  borderRadius: "10px",
                  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                  color: "#407AFF",
                  lineHeight:"1.4",
                  letterSpacing: "0.1rem",
                }}
              >
                <div className="card-body">
                  <h4 className="raamm">OUR RTL DESIGN EXPERTISE </h4>
                  <ul className="fw-bold ramParagraph">
                    <li>
                      At TechsoC we involve designing Application-Specific
                      Integrated Circuits (ASICs) or Register Transfer Level
                      (RTL) designs.
                    </li>
                    <br />
                    <li>
                      Our design engineers typically focuses on designing
                      integrated circuits for specific applications, optimizing
                      them for performance, power, and area.
                    </li>
                    <br />
                    <li>
                      We describing the behavior of a digital system at the
                      register-transfer level using hardware description
                      languages such as Verilog, VHDL, or SystemVerilog.
                    </li>
                    <br />
                    <li>
                      We work on specifying the logic and interconnections of
                      digital circuits, including processors, controllers, and
                      interfaces.
                    </li>
                    <br />
                    <li>
                      Our RTL engineers optimize designs for performance, power
                      consumption, and area constraints.
                    </li>
                    <br />
                    <li>
                      Techsoc ASIC/RTL designers collaborate closely with
                      architects, system engineers, verification engineers, and
                      physical design engineers throughout the design process.
                    </li>
                    <br />
                    <li>
                      In Techsoc we use industry-standard tools and
                      methodologies for design, verification, synthesis, timing
                      analysis, and physical implementation.
                    </li>
                  </ul>
                </div>
              </div>
            </motion.div>
          </div>

          <motion.div
            ref={ref4}
            initial="initial"
            animate={inView4 ? "visible" : "initial"}
            variants={variants3}
            transition={{ duration: 0.5, delay: 0.2 }}
            style={{ color: "#407AFF" }}
            className="d-flex justify-content-center align-items-center mt-0 overflow-auto"
          >
            <h2 className="text-white">Our RTL Design suite includes the following</h2>
          </motion.div>
          <hr class="double my-10" />
          <motion.div
            ref={ref5}
            initial="initial"
            animate={inView5 ? "visible" : "initial"}
            variants={variants3}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="row gy-3 gx-xl-8"
          >
            <div className="col-lg-3">
              <AsicCard Data={TechData[0]} />
            </div>
            <div className="col-lg-3">
              <AsicCard Data={TechData[1]} />
            </div>
            <div className="col-lg-3">
              <AsicCard Data={TechData[2]} />
            </div>
            <div className="col-lg-3">
              <AsicCard Data={TechData[3]} />
            </div>

            <hr class="double my-8" />

            <div className="col-lg-3">
              <AsicCard Data={TechData[4]} />
            </div>
            <div className="col-lg-3">
              <AsicCard Data={TechData[5]} />
            </div>
            <div className="col-lg-3">
              <AsicCard Data={TechData[6]} />
            </div>
            <div className="col-lg-3">
              <AsicCard Data={TechData[7]} />
            </div>
          </motion.div>
          <hr class="double my-8" />
        </div>
        <AmsDataOne />
      </section>
    </>
  );
};

export default AsicTech;
